module.exports = __webpack_public_path__ + "img/grey_026.2d60e6b9.png";